import { render, staticRenderFns } from "./DuplicatedLocalCharge.vue?vue&type=template&id=476c9e0b&scoped=true&"
import script from "./DuplicatedLocalCharge.vue?vue&type=script&lang=js&"
export * from "./DuplicatedLocalCharge.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatedLocalCharge.vue?vue&type=style&index=0&id=476c9e0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c9e0b",
  null
  
)

export default component.exports